import { ComponentPropsWithoutRef, forwardRef, isValidElement, memo, ReactElement } from "react"

type SVGProps = ComponentPropsWithoutRef<"svg">

export const IconAccess = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3409 12.9456C17.943 12.6102 16.1575 12.4061 14.1733 12.4718L16.2245 19.2895H22L19.3409 12.9456ZM8.36175 21.2252C8.85652 21.2252 9.16514 21.3943 9.41005 21.6728L8.9545 22.17C8.78796 21.991 8.62138 21.8767 8.35687 21.8767C7.98456 21.8767 7.72005 22.2098 7.72005 22.6027V22.6126C7.72005 23.0204 7.97968 23.3486 8.38624 23.3486C8.63607 23.3486 8.80753 23.2392 8.9888 23.0652L9.42474 23.5127C9.17003 23.7961 8.87613 24 8.35198 24C7.56331 24 6.98525 23.3834 6.98525 22.6226V22.6126C6.98525 21.8518 7.55839 21.2252 8.36175 21.2252ZM11.0746 21.2252C11.5693 21.2252 11.878 21.3943 12.1229 21.6728L11.6673 22.17C11.5008 21.991 11.3342 21.8767 11.0697 21.8767C10.6974 21.8767 10.4329 22.2098 10.4329 22.6027V22.6126C10.4329 23.0204 10.6925 23.3486 11.0991 23.3486C11.3489 23.3486 11.5204 23.2392 11.7016 23.0652L12.1376 23.5127C11.8828 23.7961 11.589 24 11.0648 24C10.2761 24 9.69811 23.3834 9.69811 22.6226V22.6126C9.69811 21.8518 10.2712 21.2252 11.0746 21.2252ZM13.7247 21.2252C14.6016 21.2252 15.0033 21.9164 15.0033 22.6723V22.6822C15.0033 22.7568 14.9983 22.8016 14.9935 22.8712H13.1663C13.2398 23.2143 13.4749 23.3933 13.808 23.3933C14.0578 23.3933 14.2391 23.3138 14.4448 23.1198L14.871 23.5027C14.6261 23.811 14.2733 24 13.7982 24C13.0095 24 12.4266 23.4381 12.4266 22.6226V22.6126C12.4266 21.8518 12.9605 21.2252 13.7247 21.2252ZM5.2933 21.2451C6.10647 21.2451 6.46408 21.6728 6.46408 22.3938V23.9403H5.74397V23.6519C5.56274 23.8558 5.31291 23.99 4.95042 23.99C4.45565 23.99 4.04908 23.7017 4.04908 23.1745V23.1646C4.04908 22.5828 4.48506 22.3142 5.10715 22.3142C5.37171 22.3142 5.56274 22.359 5.74889 22.4237V22.3789C5.74889 22.0656 5.55786 21.8916 5.18556 21.8916C4.90143 21.8916 4.70059 21.9463 4.46057 22.0358L4.27442 21.459C4.56343 21.3297 4.84756 21.2451 5.2933 21.2451ZM16.4272 21.2352C16.7603 21.2352 17.1228 21.3495 17.4069 21.5435L17.1228 22.0656C16.8632 21.9115 16.6036 21.817 16.4125 21.817C16.2313 21.817 16.1382 21.8965 16.1382 22.001V22.0109C16.1382 22.1601 16.3881 22.2297 16.6721 22.3292C17.0396 22.4535 17.4657 22.6325 17.4657 23.1198V23.1298C17.4657 23.7215 17.0298 23.99 16.4615 23.99C16.0941 23.99 15.6826 23.8658 15.3348 23.5873L15.6533 23.09C15.9374 23.2989 16.2362 23.4083 16.4811 23.4083C16.6966 23.4083 16.7946 23.3287 16.7946 23.2093V23.1994C16.7946 23.0353 16.5399 22.9806 16.2509 22.8911C15.8835 22.7817 15.4671 22.6076 15.4671 22.0905V22.0805C15.4671 21.5385 15.8982 21.2352 16.4272 21.2352ZM18.8917 21.2352C19.2248 21.2352 19.5873 21.3495 19.8714 21.5435L19.5873 22.0656C19.3277 21.9115 19.068 21.817 18.877 21.817C18.6958 21.817 18.6027 21.8965 18.6027 22.001V22.0109C18.6027 22.1601 18.8525 22.2297 19.1366 22.3292C19.504 22.4535 19.9302 22.6325 19.9302 23.1198V23.1298C19.9302 23.7215 19.4942 23.99 18.926 23.99C18.5586 23.99 18.1471 23.8658 17.7993 23.5873L18.1177 23.09C18.4018 23.2989 18.7007 23.4083 18.9456 23.4083C19.1611 23.4083 19.2591 23.3287 19.2591 23.2093V23.1994C19.2591 23.0353 19.0044 22.9806 18.7154 22.8911C18.348 22.7817 17.9316 22.6076 17.9316 22.0905V22.0805C17.9316 21.5385 18.3627 21.2352 18.8917 21.2352ZM5.28354 22.7668C4.96511 22.7668 4.76915 22.8961 4.76915 23.1348V23.1447C4.76915 23.3486 4.93573 23.4679 5.17575 23.4679C5.52356 23.4679 5.7587 23.274 5.7587 23.0005V22.8662C5.6313 22.8066 5.46476 22.7668 5.28354 22.7668ZM13.7247 21.8319C13.4161 21.8319 13.2153 22.0557 13.1565 22.3988H14.2783C14.2342 22.0606 14.0382 21.8319 13.7247 21.8319ZM9.5203 13.1278L7.66776 19.2895H2L3.49111 15.7325C5.45139 14.4642 7.51218 13.6332 9.5203 13.1278ZM13.9124 0L18.6324 11.2569C18.0603 11.0673 17.426 10.9167 16.7463 10.8123C15.7841 10.664 14.7286 10.6057 13.6275 10.6567C12.4858 10.7102 11.2964 10.8754 10.1067 11.1767C9.19246 11.4051 8.2781 11.7137 7.38776 12.1122C6.27713 12.6029 5.20481 13.2274 4.21396 14.0049L10.0852 0H13.9124ZM11.8612 5.4207H11.8372C10.7099 5.43284 9.80041 6.36587 9.80041 7.51511C9.80041 8.22943 10.1522 8.85876 10.6907 9.23778C11.0235 9.47104 11.4255 9.60713 11.8612 9.60713C12.3567 9.60713 12.8138 9.42977 13.1704 9.13578C13.63 8.74942 13.9244 8.16624 13.9244 7.51511C13.9244 6.42418 13.1034 5.53004 12.0551 5.43046C11.9904 5.42308 11.9258 5.4207 11.8612 5.4207Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconAccount = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0001 3C9.65291 3 7.75012 4.90279 7.75012 7.25C7.75012 9.59721 9.65291 11.5 12.0001 11.5C14.3473 11.5 16.2501 9.59721 16.2501 7.25C16.2501 4.90279 14.3473 3 12.0001 3ZM16.7746 14.3051C13.8523 12.565 10.1479 12.565 7.22562 14.3051C7.1248 14.3651 7.00183 14.4345 6.86369 14.5125C6.26849 14.8485 5.39154 15.3436 4.78982 15.9325C4.41356 16.3008 4.07177 16.7717 4.00992 17.3376C3.94469 17.9343 4.20231 18.5049 4.74912 19.0259C5.71402 19.9451 6.85607 20.6667 8.32584 20.6667H15.6744C17.1442 20.6667 18.2862 19.9451 19.2511 19.0258C19.7979 18.5049 20.0555 17.9343 19.9903 17.3376C19.9284 16.7717 19.5867 16.3008 19.2104 15.9325C18.6087 15.3435 17.7317 14.8485 17.1365 14.5125L17.1365 14.5125C16.9984 14.4345 16.8754 14.3651 16.7746 14.3051Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconCalendar = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M7.91567 4.99421V6.74437M16.0826 4.99316V6.74333M4.9978 17.2433V8.49233C4.9978 7.52578 5.78134 6.74224 6.74788 6.74224H17.2477C18.2143 6.74224 18.9978 7.52578 18.9978 8.49233V17.2433M4.9978 17.2433C4.9978 18.2099 5.78134 18.9934 6.74788 18.9934H17.2477C18.2143 18.9934 18.9978 18.2099 18.9978 17.2433M4.9978 17.2433V11.4097C4.9978 10.4431 5.78134 9.65956 6.74788 9.65956H17.2477C18.2143 9.65956 18.9978 10.4431 18.9978 11.4097V17.2433M13.7478 12.5763H15.4978M8.49777 14.3265H11.9978M11.9994 12.5763H12.0038V12.5807H11.9994V12.5763ZM11.9989 16.0769H12.0033V16.0813H11.9989V16.0769ZM10.2486 16.0774H10.253V16.0818H10.2486V16.0774ZM8.49834 16.0769H8.50271V16.0813H8.49834V16.0769ZM13.7486 14.3294H13.7529V14.3338H13.7486V14.3294ZM13.7492 16.0775H13.7536V16.0818H13.7492V16.0775ZM15.4994 14.3283H15.5038V14.3327H15.4994V14.3283Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </svg>
    )
  }),
)

export const IconCaretDown = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.29297 10.7072L7.70718 9.29297L12.0001 13.5859L16.293 9.29297L17.7072 10.7072L12.0001 16.4143L6.29297 10.7072Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconCart = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M8.58332 14.6667H14.636C18.3757 14.6667 18.9444 12.3173 19.6342 8.8909C19.8332 7.90259 19.9327 7.40844 19.6934 7.07923C19.4542 6.75 18.9956 6.75 18.0784 6.75H6.91666"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.2185 6.29734C19.5469 6.34947 19.87 6.47174 20.0979 6.78529C20.3181 7.08834 20.3502 7.43495 20.3269 7.77225C20.3048 8.09326 20.2248 8.49069 20.1309 8.95688L20.1243 8.98957C19.785 10.675 19.4561 12.2301 18.6913 13.3463C18.2975 13.921 17.7872 14.3845 17.1081 14.6996C16.4347 15.0121 15.6216 15.1667 14.636 15.1667H8.58332C8.30718 15.1667 8.08332 14.9428 8.08332 14.6667C8.08332 14.3905 8.30718 14.1667 8.58332 14.1667H14.636C15.5202 14.1667 16.1805 14.0276 16.6872 13.7925C17.1881 13.56 17.5642 13.2221 17.8663 12.7811C18.4933 11.8661 18.7935 10.5332 19.144 8.79223C19.2463 8.28425 19.3122 7.95152 19.3293 7.70356C19.3458 7.4644 19.3079 7.39933 19.2889 7.37317L19.288 7.37184C19.276 7.35522 19.2467 7.31433 19.0617 7.28497C18.8509 7.25149 18.5542 7.25 18.0784 7.25H6.91666C6.64051 7.25 6.41666 7.02614 6.41666 6.75C6.41666 6.47386 6.64051 6.25 6.91666 6.25L18.1165 6.25C18.5423 6.24996 18.9199 6.24992 19.2185 6.29734Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5 2.5H4.78204C5.77625 2.5 6.64288 3.17664 6.88401 4.14118L6.88632 4.1504L9.1754 15.0533L8.19674 15.2587L5.91174 4.3753C5.77899 3.86042 5.31449 3.5 4.78204 3.5H3.5V2.5Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.41666 16.8095C6.41666 15.3694 7.54249 14.1667 8.9738 14.1667H9.31666C9.5928 14.1667 9.81666 14.3905 9.81666 14.6667C9.81666 14.9428 9.5928 15.1667 9.31666 15.1667H8.9738C8.1766 15.1667 7.4915 15.8102 7.42239 16.6667H16.5C16.7761 16.6667 17 16.8905 17 17.1667C17 17.4428 16.7761 17.6667 16.5 17.6667H7.25951C6.77493 17.6667 6.41666 17.2634 6.41666 16.8095Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.91666 18.4167C8.91666 17.4502 9.70016 16.6667 10.6667 16.6667C11.6332 16.6667 12.4167 17.4502 12.4167 18.4167C12.4167 19.3832 11.6332 20.1667 10.6667 20.1667C9.70016 20.1667 8.91666 19.3832 8.91666 18.4167Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.75 18.4167C14.75 17.4502 15.5335 16.6667 16.5 16.6667C17.4665 16.6667 18.25 17.4502 18.25 18.4167C18.25 19.3832 17.4665 20.1667 16.5 20.1667C15.5335 20.1667 14.75 19.3832 14.75 18.4167Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronDown = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M13.2839 13.517C12.845 14.0631 12.6256 14.3361 12.3605 14.435C12.128 14.5217 11.872 14.5217 11.6395 14.435C11.3744 14.3361 11.155 14.0631 10.7161 13.517L10.0266 12.6591C9.34245 11.8078 9.00039 11.3822 9 11.024C8.99966 10.7125 9.14195 10.4178 9.38654 10.2235C9.66777 10 10.2153 10 11.3105 10L12.6895 10C13.7847 10 14.3322 10 14.6135 10.2235C14.858 10.4178 15.0003 10.7125 15 11.024C14.9996 11.3822 14.6575 11.8078 13.9734 12.6591L13.2839 13.517Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronLeft = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M10.733 13.5339C10.1869 13.095 9.91386 12.8756 9.815 12.6105C9.72833 12.378 9.72833 12.122 9.815 11.8895C9.91386 11.6244 10.1869 11.405 10.733 10.9661L11.5909 10.2766C12.4422 9.59245 12.8678 9.25039 13.226 9.25C13.5375 9.24966 13.8322 9.39195 14.0265 9.63654C14.25 9.91777 14.25 10.4653 14.25 11.5605L14.25 12.9395C14.25 14.0347 14.25 14.5822 14.0265 14.8635C13.8322 15.108 13.5375 15.2503 13.226 15.25C12.8678 15.2496 12.4422 14.9075 11.5909 14.2234L10.733 13.5339Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronRight = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M13.267 10.9661C13.8131 11.405 14.0861 11.6244 14.185 11.8895C14.2717 12.122 14.2717 12.378 14.185 12.6105C14.0861 12.8756 13.8131 13.095 13.267 13.5339L12.4091 14.2234C11.5578 14.9075 11.1322 15.2496 10.774 15.25C10.4625 15.2503 10.1678 15.108 9.97346 14.8635C9.75 14.5822 9.75 14.0347 9.75 12.9395L9.75 11.5605C9.75 10.4653 9.75 9.91777 9.97346 9.63654C10.1678 9.39195 10.4625 9.24966 10.774 9.25C11.1322 9.25039 11.5578 9.59245 12.4091 10.2766L13.267 10.9661Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronUp = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M13.2839 9.98297C12.845 9.4369 12.6256 9.16386 12.3605 9.065C12.128 8.97833 11.872 8.97833 11.6395 9.065C11.3744 9.16386 11.155 9.4369 10.7161 9.98297L10.0266 10.8409C9.34245 11.6922 9.00039 12.1178 9 12.476C8.99966 12.7875 9.14195 13.0822 9.38654 13.2765C9.66777 13.5 10.2153 13.5 11.3105 13.5L12.6895 13.5C13.7847 13.5 14.3322 13.5 14.6135 13.2765C14.858 13.0822 15.0003 12.7875 15 12.476C14.9996 12.1178 14.6575 11.6922 13.9734 10.8409L13.2839 9.98297Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconCross = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.51996 6.51996C6.81286 6.22707 7.28773 6.22707 7.58062 6.51996L17.4801 16.4195C17.773 16.7124 17.773 17.1872 17.4801 17.4801C17.1872 17.773 16.7124 17.773 16.4195 17.4801L6.51996 7.58062C6.22707 7.28773 6.22707 6.81286 6.51996 6.51996Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.4801 6.51996C17.773 6.81286 17.773 7.28773 17.4801 7.58062L7.58062 17.4801C7.28773 17.773 6.81286 17.773 6.51996 17.4801C6.22707 17.1872 6.22707 16.7124 6.51996 16.4195L16.4195 6.51996C16.7124 6.22707 17.1872 6.22707 17.4801 6.51996Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconDay = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M5 12.0001H19M5 15.1819H19M5 18.3637H19M6.59091 5.63647H17.4091C18.2877 5.63647 19 6.34875 19 7.22738C19 8.10602 18.2877 8.81829 17.4091 8.81829H6.59091C5.71227 8.81829 5 8.10602 5 7.22738C5 6.34875 5.71227 5.63647 6.59091 5.63647Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    )
  }),
)

export const IconDownload = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.5C12.3186 4.5 12.5769 4.7583 12.5769 5.07692V14.0687L15.0536 11.5921C15.2789 11.3668 15.6442 11.3668 15.8695 11.5921C16.0948 11.8174 16.0948 12.1826 15.8695 12.4079L12.4079 15.8695C12.1826 16.0948 11.8174 16.0948 11.5921 15.8695L8.13052 12.4079C7.90521 12.1826 7.90521 11.8174 8.13052 11.5921C8.35582 11.3668 8.72111 11.3668 8.94641 11.5921L11.4231 14.0687V5.07692C11.4231 4.7583 11.6814 4.5 12 4.5ZM5.07692 14.8846C5.39555 14.8846 5.65385 15.1429 5.65385 15.4615V17.1923C5.65385 17.8296 6.17044 18.3462 6.80769 18.3462H17.1923C17.8296 18.3462 18.3462 17.8296 18.3462 17.1923V15.4615C18.3462 15.1429 18.6045 14.8846 18.9231 14.8846C19.2417 14.8846 19.5 15.1429 19.5 15.4615V17.1923C19.5 18.4668 18.4668 19.5 17.1923 19.5H6.80769C5.53319 19.5 4.5 18.4668 4.5 17.1923V15.4615C4.5 15.1429 4.7583 14.8846 5.07692 14.8846Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconEllipsis = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.5 12C4.5 11.1716 5.17157 10.5 6 10.5C6.82843 10.5 7.5 11.1716 7.5 12C7.5 12.8284 6.82843 13.5 6 13.5C5.17157 13.5 4.5 12.8284 4.5 12ZM10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12ZM16.5 12C16.5 11.1716 17.1716 10.5 18 10.5C18.8284 10.5 19.5 11.1716 19.5 12C19.5 12.8284 18.8284 13.5 18 13.5C17.1716 13.5 16.5 12.8284 16.5 12Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconExternalLink = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6923 5L18.4615 5C18.6043 5 18.7413 5.05673 18.8423 5.15771C18.9433 5.25869 19 5.39565 19 5.53846V9.30769C19 9.60508 18.7589 9.84615 18.4615 9.84615C18.1642 9.84615 17.9231 9.60508 17.9231 9.30769V6.83842L9.14998 15.6115C8.9397 15.8218 8.59876 15.8218 8.38848 15.6115C8.1782 15.4012 8.1782 15.0603 8.38848 14.85L17.1616 6.07692L14.6923 6.07692C14.3949 6.07692 14.1538 5.83585 14.1538 5.53846C14.1538 5.24108 14.3949 5 14.6923 5ZM7.15385 8.23077C6.55908 8.23077 6.07692 8.71292 6.07692 9.30769V16.8462C6.07692 17.4409 6.55908 17.9231 7.15385 17.9231H14.6923C15.2871 17.9231 15.7692 17.4409 15.7692 16.8462V10.9231C15.7692 10.6257 16.0103 10.3846 16.3077 10.3846C16.6051 10.3846 16.8462 10.6257 16.8462 10.9231V16.8462C16.8462 18.0357 15.8818 19 14.6923 19H7.15385C5.96431 19 5 18.0357 5 16.8462V9.30769C5 8.11816 5.96431 7.15385 7.15385 7.15385H13.0769C13.3743 7.15385 13.6154 7.39492 13.6154 7.69231C13.6154 7.98969 13.3743 8.23077 13.0769 8.23077H7.15385Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconFilm = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M5.80769 17H18.1923M5.80769 17C5.36162 17 5 16.6642 5 16.25M5.80769 17H6.88462C7.33069 17 7.69231 16.6642 7.69231 16.25M5 16.25V7.75M5 16.25V15.25C5 14.8358 5.36162 14.5 5.80769 14.5M19 16.25V7.75M19 16.25C19 16.6642 18.6384 17 18.1923 17M19 16.25V15.25C19 14.8358 18.6384 14.5 18.1923 14.5M18.1923 17H17.1154C16.6693 17 16.3077 16.6642 16.3077 16.25M18.1923 7H5.80769M18.1923 7C18.6384 7 19 7.33579 19 7.75M18.1923 7H17.1154C16.6693 7 16.3077 7.33579 16.3077 7.75M19 7.75V8.75C19 9.16421 18.6384 9.5 18.1923 9.5M5.80769 7C5.36162 7 5 7.33579 5 7.75M5.80769 7H6.88462C7.33069 7 7.69231 7.33579 7.69231 7.75M5 7.75V8.75C5 9.16421 5.36162 9.5 5.80769 9.5M5.80769 9.5H6.88462M5.80769 9.5C5.36162 9.5 5 9.83579 5 10.25V11.25C5 11.6642 5.36162 12 5.80769 12M6.88462 9.5C7.33069 9.5 7.69231 9.16421 7.69231 8.75V7.75M6.88462 9.5C7.33069 9.5 7.69231 9.83579 7.69231 10.25V11.25M7.69231 7.75V11.25M7.69231 7.75C7.69231 7.33579 8.05392 7 8.5 7H15.5C15.9461 7 16.3077 7.33579 16.3077 7.75M17.1154 9.5H18.1923M17.1154 9.5C16.6693 9.5 16.3077 9.16421 16.3077 8.75V7.75M17.1154 9.5C16.6693 9.5 16.3077 9.83579 16.3077 10.25V11.25M18.1923 9.5C18.6384 9.5 19 9.83579 19 10.25V11.25C19 11.6642 18.6384 12 18.1923 12M16.3077 7.75V11.25M8.5 12H15.5M8.5 12C8.05392 12 7.69231 11.6642 7.69231 11.25M8.5 12C8.05392 12 7.69231 12.3358 7.69231 12.75M7.69231 11.25C7.69231 11.6642 7.33069 12 6.88462 12M16.3077 11.25C16.3077 11.6642 15.9461 12 15.5 12M16.3077 11.25C16.3077 11.6642 16.6693 12 17.1154 12M15.5 12C15.9461 12 16.3077 12.3358 16.3077 12.75M7.69231 16.25V12.75M7.69231 16.25C7.69231 16.6642 8.05392 17 8.5 17H15.5C15.9461 17 16.3077 16.6642 16.3077 16.25M7.69231 16.25V15.25C7.69231 14.8358 7.33069 14.5 6.88462 14.5M16.3077 16.25V12.75M16.3077 16.25V15.25C16.3077 14.8358 16.6693 14.5 17.1154 14.5M16.3077 12.75V13.75C16.3077 14.1642 16.6693 14.5 17.1154 14.5M16.3077 12.75C16.3077 12.3358 16.6693 12 17.1154 12M7.69231 12.75V13.75C7.69231 14.1642 7.33069 14.5 6.88462 14.5M7.69231 12.75C7.69231 12.3358 7.33069 12 6.88462 12M5.80769 12H6.88462M5.80769 12C5.36162 12 5 12.3358 5 12.75V13.75C5 14.1642 5.36162 14.5 5.80769 14.5M17.1154 12H18.1923M18.1923 12C18.6384 12 19 12.3358 19 12.75V13.75C19 14.1642 18.6384 14.5 18.1923 14.5M5.80769 14.5H6.88462M17.1154 14.5H18.1923"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    )
  }),
)

export const IconFilters = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M10.75 7.37891C10.75 7.03373 10.4702 6.75391 10.125 6.75391C9.77982 6.75391 9.5 7.03373 9.5 7.37891V9.87891C9.5 10.2241 9.77982 10.5039 10.125 10.5039C10.4702 10.5039 10.75 10.2241 10.75 9.87891V9.25391H16.375C16.7202 9.25391 17 8.97408 17 8.62891C17 8.28373 16.7202 8.00391 16.375 8.00391H10.75V7.37891Z"
          fill="currentColor"
        ></path>
        <path
          d="M14.5 10.9206C14.5 10.5754 14.2202 10.2956 13.875 10.2956C13.5298 10.2956 13.25 10.5754 13.25 10.9206V13.4206C13.25 13.7658 13.5298 14.0456 13.875 14.0456C14.2202 14.0456 14.5 13.7658 14.5 13.4206V12.7956H16.375C16.7202 12.7956 17 12.5158 17 12.1706C17 11.8254 16.7202 11.5456 16.375 11.5456H14.5V10.9206Z"
          fill="currentColor"
        ></path>
        <path
          d="M10.125 13.8372C10.4702 13.8372 10.75 14.1171 10.75 14.4622V15.0872H16.375C16.7202 15.0872 17 15.3671 17 15.7122C17 16.0574 16.7202 16.3372 16.375 16.3372H10.75V16.9622C10.75 17.3074 10.4702 17.5872 10.125 17.5872C9.77982 17.5872 9.5 17.3074 9.5 16.9622V14.4622C9.5 14.1171 9.77982 13.8372 10.125 13.8372Z"
          fill="currentColor"
        ></path>
        <path
          d="M7.625 11.5456H12.4167V12.7956H7.625C7.27982 12.7956 7 12.5158 7 12.1706C7 11.8254 7.27982 11.5456 7.625 11.5456Z"
          fill="currentColor"
        ></path>
        <path
          d="M8.66667 8.00391H7.625C7.27982 8.00391 7 8.28373 7 8.62891C7 8.97408 7.27982 9.25391 7.625 9.25391H8.66667V8.00391Z"
          fill="currentColor"
        ></path>
        <path
          d="M7.625 15.0872H8.66667V16.3372H7.625C7.27982 16.3372 7 16.0574 7 15.7122C7 15.3671 7.27982 15.0872 7.625 15.0872Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconGift = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.82 5.5C9.01366 5.5 8.36 6.15366 8.36 6.96C8.36 7.76634 9.01366 8.42 9.82 8.42H11.28V6.96C11.28 6.15366 10.6263 5.5 9.82 5.5ZM11.78 5.47317C11.3307 4.88183 10.62 4.5 9.82 4.5C8.46138 4.5 7.36 5.60138 7.36 6.96C7.36 7.50664 7.53829 8.01163 7.8399 8.42H5.34C4.59994 8.42 4 9.01994 4 9.76V10.88C4 11.5451 4.48461 12.0971 5.12 12.202V17.88C5.12 18.7747 5.8453 19.5 6.74 19.5H17.38C18.2747 19.5 19 18.7747 19 17.88V12.202C19.6354 12.0971 20.12 11.5451 20.12 10.88V9.76C20.12 9.01994 19.5201 8.42 18.78 8.42H15.7201C16.0217 8.01163 16.2 7.50664 16.2 6.96C16.2 5.60138 15.0986 4.5 13.74 4.5C12.9401 4.5 12.2293 4.88183 11.78 5.47317ZM12.28 9.42V11.22H18.78C18.9678 11.22 19.12 11.0678 19.12 10.88V9.76C19.12 9.57222 18.9678 9.42 18.78 9.42H12.28ZM18 12.22H12.28V18.5H17.38C17.7224 18.5 18 18.2224 18 17.88V12.22ZM11.28 18.5V12.22H6.12V17.88C6.12 18.2224 6.39758 18.5 6.74 18.5H11.28ZM11.28 11.22V9.42H5.34C5.15222 9.42 5 9.57222 5 9.76V10.88C5 11.0678 5.15222 11.22 5.34 11.22H11.28ZM12.28 8.42H13.74C14.5463 8.42 15.2 7.76634 15.2 6.96C15.2 6.15366 14.5463 5.5 13.74 5.5C12.9337 5.5 12.28 6.15366 12.28 6.96V8.42Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconGuest = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M10.487 8.56094C10.6591 8.40484 10.9229 8.38612 11.1178 8.52872C11.3128 8.67139 11.3748 8.92868 11.278 9.14005L11.2262 9.22696L7.03774 14.9496C7.00973 14.9879 6.99701 15.0352 7.00063 15.0824C7.00246 15.1063 7.00831 15.1294 7.0182 15.1508L7.05824 15.2074L7.62953 15.7797C7.66346 15.8135 7.70771 15.834 7.75551 15.8373C7.80347 15.8405 7.85109 15.8254 7.8893 15.7963L13.3776 11.6078C13.5971 11.4407 13.9104 11.4832 14.0778 11.7025C14.2452 11.9219 14.2032 12.2351 13.984 12.4027L8.49672 16.5912C8.26615 16.7674 7.97961 16.8535 7.69008 16.8344C7.43651 16.8176 7.19543 16.7215 7.0016 16.56L6.92152 16.4867L6.35024 15.9145L6.35121 15.9135C6.14926 15.7113 6.02556 15.4445 6.00356 15.1596C5.98157 14.8742 6.06203 14.5897 6.2311 14.3588L10.4196 8.63712L10.487 8.56094Z"
          fill="currentColor"
        ></path>
        <path
          d="M6.64783 15.4744C6.85439 15.2912 7.17063 15.3099 7.35389 15.5164C7.53706 15.7229 7.51825 16.0392 7.31189 16.2225C7.06593 16.4407 6.94477 16.9306 7.10682 17.4832C7.26344 18.017 7.63237 18.4173 8.11268 18.4998C8.63789 18.59 9.17456 18.3433 9.88514 17.95C10.2162 17.7668 10.5876 17.5522 10.9633 17.3895C11.3435 17.2248 11.766 17.0955 12.2201 17.0955C13.1744 17.0955 13.9711 17.402 14.6576 17.8172L14.9447 18.0008L15.0228 18.0653C15.186 18.2312 15.2156 18.4947 15.0804 18.6951C14.9453 18.8957 14.6901 18.9667 14.475 18.8778L14.3861 18.8299L14.141 18.6737C13.5633 18.324 12.9436 18.0955 12.2201 18.0955C11.9553 18.0955 11.6751 18.1713 11.3607 18.3074C11.0417 18.4456 10.7258 18.6278 10.3695 18.825C9.70567 19.1925 8.865 19.6436 7.94275 19.4852C6.97567 19.3188 6.3751 18.5428 6.14686 17.7645C5.92409 17.0048 6.00296 16.0465 6.64783 15.4744Z"
          fill="currentColor"
        ></path>
        <path
          d="M17.3099 8.51147C17.3097 6.85835 15.969 5.51831 14.3158 5.51831C12.6628 5.51855 11.3229 6.8585 11.3226 8.51147C11.3226 10.1647 12.6627 11.5054 14.3158 11.5056C15.9691 11.5056 17.3099 10.1648 17.3099 8.51147ZM18.3099 8.51147C18.3099 10.7171 16.5214 12.5056 14.3158 12.5056C12.1104 12.5054 10.3226 10.7169 10.3226 8.51147C10.3229 6.30622 12.1105 4.51855 14.3158 4.51831C16.5213 4.51831 18.3097 6.30607 18.3099 8.51147Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconInfo = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5ZM3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12ZM12 8.83333C12.2761 8.83333 12.5 9.05719 12.5 9.33333V12.6667C12.5 12.9428 12.2761 13.1667 12 13.1667C11.7239 13.1667 11.5 12.9428 11.5 12.6667V9.33333C11.5 9.05719 11.7239 8.83333 12 8.83333ZM11.5 15.3333C11.5 15.0572 11.7239 14.8333 12 14.8333H12.0067C12.2828 14.8333 12.5067 15.0572 12.5067 15.3333V15.34C12.5067 15.6161 12.2828 15.84 12.0067 15.84H12C11.7239 15.84 11.5 15.6161 11.5 15.34V15.3333Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconLink = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4029 7.59705C15.6069 6.80098 14.3162 6.80098 13.5201 7.59705L10.9817 10.1355C10.1856 10.9316 10.1856 12.2223 10.9817 13.0183C11.1508 13.1874 11.3413 13.32 11.5441 13.4169C11.7933 13.5359 11.8988 13.8344 11.7797 14.0836C11.6607 14.3328 11.3622 14.4383 11.113 14.3192C10.8093 14.1741 10.525 13.9759 10.2746 13.7254C9.08797 12.5388 9.08797 10.615 10.2746 9.42841L12.813 6.88994C13.9996 5.70335 15.9235 5.70335 17.1101 6.88994C18.2966 8.07654 18.2966 10.0004 17.1101 11.187L16.1189 12.1781C15.9237 12.3734 15.6071 12.3734 15.4118 12.1781C15.2166 11.9828 15.2166 11.6662 15.4118 11.471L16.4029 10.4799C17.199 9.6838 17.199 8.39312 16.4029 7.59705ZM12.2203 9.91641C12.3393 9.66723 12.6378 9.56173 12.887 9.68076C13.1907 9.82589 13.475 10.0241 13.7254 10.2746C14.912 11.4612 14.912 13.385 13.7254 14.5716L11.187 17.1101C10.0004 18.2966 8.07654 18.2966 6.88994 17.1101C5.70335 15.9235 5.70335 13.9996 6.88994 12.813L7.88106 11.8219C8.07632 11.6266 8.3929 11.6266 8.58816 11.8219C8.78343 12.0172 8.78343 12.3338 8.58816 12.529L7.59705 13.5201C6.80098 14.3162 6.80098 15.6069 7.59705 16.4029C8.39312 17.199 9.6838 17.199 10.4799 16.4029L13.0183 13.8645C13.8144 13.0684 13.8144 11.7777 13.0183 10.9817C12.8492 10.8126 12.6587 10.68 12.4559 10.5831C12.2067 10.4641 12.1012 10.1656 12.2203 9.91641Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconLoad = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <mask
          id="mask0_4127_17320"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="5"
          y="5"
          width="14"
          height="14"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12ZM5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12Z"
            fill="currentColor"
          ></path>
        </mask>
        <g mask="url(#mask0_4127_17320)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 12.4488L13 6.08392C13.6514 6.19403 14.2825 6.41137 14.8669 6.72924C15.7467 7.20779 16.4927 7.89895 17.0369 8.73971C17.5811 9.58047 17.9062 10.5441 17.9825 11.5427C18.0589 12.5413 17.884 13.5431 17.4739 14.4568C17.0638 15.3705 16.4315 16.1671 15.6347 16.7738C14.8379 17.3805 13.9018 17.7781 12.912 17.9303C11.9221 18.0825 10.9098 17.9845 9.96752 17.6453C9.3416 17.4199 8.75976 17.0929 8.24451 16.6793L13 12.4488ZM6.77 16.6526C6.99313 16.9035 7.23327 17.1371 7.48831 17.3521C8.12097 17.8854 8.84527 18.3041 9.62878 18.5861C10.7281 18.9819 11.9091 19.0963 13.0639 18.9187C14.2188 18.7411 15.3109 18.2772 16.2405 17.5694C17.1701 16.8616 17.9078 15.9323 18.3863 14.8663C18.8647 13.8003 19.0687 12.6315 18.9796 11.4665C18.8906 10.3014 18.5113 9.17722 17.8764 8.19633C17.2415 7.21544 16.3711 6.40908 15.3447 5.85078C14.6132 5.45288 13.819 5.19 13 5.07179C12.6699 5.02414 12.3357 5 12 5L12 12L6.77 16.6526Z"
            fill="currentColor"
          ></path>
        </g>
      </svg>
    )
  }),
)

export const IconMenu = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.25 7C4.25 6.58579 4.58579 6.25 5 6.25H19C19.4142 6.25 19.75 6.58579 19.75 7C19.75 7.41421 19.4142 7.75 19 7.75H5C4.58579 7.75 4.25 7.41421 4.25 7Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.25 17C4.25 16.5858 4.58579 16.25 5 16.25H19C19.4142 16.25 19.75 16.5858 19.75 17C19.75 17.4142 19.4142 17.75 19 17.75H5C4.58579 17.75 4.25 17.4142 4.25 17Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconMinus = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconMoney = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M4 17.6635C8.4859 17.6635 12.8317 18.2635 16.9614 19.3876C17.558 19.5499 18.1538 19.1064 18.1538 18.4882V17.6635M5.23077 5.97119V6.58658C5.23077 6.92644 4.95525 7.20196 4.61538 7.20196H4M4 7.20196V6.89427C4 6.38447 4.41328 5.97119 4.92308 5.97119H18.7692M4 7.20196V14.5866M18.7692 5.97119V6.58658C18.7692 6.92644 19.0447 7.20196 19.3846 7.20196H20M18.7692 5.97119H19.0769C19.5867 5.97119 20 6.38447 20 6.89427V14.8943C20 15.4041 19.5867 15.8173 19.0769 15.8173H18.7692M20 14.5866H19.3846C19.0447 14.5866 18.7692 14.8621 18.7692 15.202V15.8173M18.7692 15.8173H5.23077M5.23077 15.8173H4.92308C4.41328 15.8173 4 15.4041 4 14.8943V14.5866M5.23077 15.8173V15.202C5.23077 14.8621 4.95525 14.5866 4.61538 14.5866H4M14.4615 10.8943C14.4615 12.2537 13.3595 13.3558 12 13.3558C10.6405 13.3558 9.53846 12.2537 9.53846 10.8943C9.53846 9.5348 10.6405 8.43273 12 8.43273C13.3595 8.43273 14.4615 9.5348 14.4615 10.8943ZM16.9231 10.8943H16.9292V10.9004H16.9231V10.8943ZM7.07692 10.8943H7.08308V10.9004H7.07692V10.8943Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    )
  }),
)

export const IconMuted = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M11.6193 6.16552L8.23077 9.69543H6.62189C5.99056 9.69543 5.39911 10.0742 5.23145 10.7083C5.08058 11.2788 5 11.8796 5 12.5001C5 13.1206 5.08058 13.7214 5.23145 14.2919C5.39911 14.926 5.99056 15.3048 6.62189 15.3048H8.23077L11.6193 18.8347C11.9585 19.1881 12.5385 18.9378 12.5385 18.438V6.56216C12.5385 6.06242 11.9585 5.81215 11.6193 6.16552Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.993 6.50093C11.9918 6.50159 11.9872 6.50425 11.98 6.51177L8.59147 10.0417C8.49719 10.1399 8.36692 10.1954 8.23077 10.1954H6.62189C6.17945 10.1954 5.81531 10.4561 5.71483 10.8361C5.57493 11.3652 5.5 11.9231 5.5 12.5001C5.5 13.0771 5.57493 13.635 5.71483 14.1641C5.81531 14.5441 6.17945 14.8048 6.62189 14.8048H8.23077C8.36692 14.8048 8.49719 14.8603 8.59147 14.9585L11.98 18.4884C11.9872 18.496 11.9918 18.4986 11.993 18.4993C11.9944 18.5 11.9948 18.5 11.9948 18.5C11.995 18.5 11.9997 18.5008 12.008 18.4972C12.0163 18.4936 12.0235 18.4876 12.0284 18.4804C12.032 18.4751 12.0385 18.4634 12.0385 18.438V6.56216C12.0385 6.53684 12.032 6.52511 12.0284 6.51982C12.0235 6.5126 12.0163 6.50658 12.008 6.50301C11.9997 6.49944 11.995 6.50016 11.9948 6.50019C11.9948 6.50019 11.9944 6.50021 11.993 6.50093ZM11.2585 5.81927C11.9403 5.10907 13.0385 5.6567 13.0385 6.56216V18.438C13.0385 19.3435 11.9403 19.8911 11.2585 19.1809L8.01765 15.8048H6.62189C5.80167 15.8048 4.98292 15.3079 4.74806 14.4197C4.58624 13.8078 4.5 13.164 4.5 12.5001C4.5 11.8362 4.58624 11.1924 4.74806 10.5805C4.98292 9.69231 5.80167 9.19543 6.62189 9.19543H8.01765L11.2585 5.81927ZM15.423 10.4566C15.6222 10.2654 15.9387 10.2718 16.1299 10.471L17.3846 11.7781L18.6393 10.471C18.8305 10.2718 19.147 10.2654 19.3463 10.4566C19.5455 10.6478 19.5519 10.9643 19.3607 11.1635L18.0777 12.5001L19.3607 13.8367C19.5519 14.0359 19.5455 14.3524 19.3463 14.5436C19.147 14.7348 18.8305 14.7284 18.6393 14.5292L17.3846 13.2221L16.1299 14.5292C15.9387 14.7284 15.6222 14.7348 15.423 14.5436C15.2238 14.3524 15.2173 14.0359 15.4085 13.8367L16.6915 12.5001L15.4085 11.1635C15.2173 10.9643 15.2238 10.6478 15.423 10.4566Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconPlaceholder = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <circle cx="12" cy="12" r="6" fill="currentColor"></circle>
      </svg>
    )
  }),
)

export const IconPlanner = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M18.0634 5.34699C19.6331 6.30983 20.5262 8.32836 20.2131 10.6626C19.8987 13.0067 18.3796 15.6705 15.1423 18.0667L15.0704 18.1199C13.9335 18.9618 13.2067 19.5 11.9977 19.5C10.7888 19.5 10.062 18.9618 8.92507 18.1199L8.85324 18.0667C5.61585 15.6705 4.09675 13.0067 3.78237 10.6626C3.4693 8.32836 4.3624 6.30983 5.93208 5.34699C8.21734 3.94522 10.2602 4.50467 11.4934 5.4308C11.7236 5.60365 11.8763 5.71796 11.988 5.79114L11.9977 5.79744L12.0074 5.79114C12.1192 5.71797 12.2718 5.60366 12.502 5.43083C13.7352 4.50468 15.7781 3.94521 18.0634 5.34699Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconPlannerEmpty = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.777 6.31214C10.7 5.50332 8.91722 5.01753 6.92993 6.23653L11.777 6.31214ZM11.1765 7.11178C10.3789 6.51275 9.04102 6.11473 7.4528 7.08894C6.48072 7.68522 5.81536 9.01807 6.045 10.7303C6.27332 12.4327 7.39809 14.5104 10.0236 16.4537C11.0783 17.2344 11.4633 17.5 12.1664 17.5C12.8695 17.5 13.2545 17.2344 14.3093 16.4537C16.9347 14.5104 18.0595 12.4327 18.2878 10.7303C18.5174 9.01807 17.8521 7.68521 16.88 7.08894C15.2918 6.11472 13.9539 6.51275 13.1563 7.11178L13.1418 7.12263C12.9617 7.25785 12.8071 7.374 12.6833 7.45501C12.619 7.49715 12.5477 7.54007 12.4737 7.5735C12.4035 7.60523 12.2956 7.64492 12.1664 7.64492C12.0372 7.64492 11.9293 7.60523 11.8591 7.5735C11.7851 7.54007 11.7139 7.49715 11.6495 7.45501C11.5257 7.374 11.3711 7.25785 11.191 7.12263L11.1765 7.11178ZM12.5558 6.31214C13.6328 5.50332 15.4156 5.01753 17.4029 6.23652C18.777 7.07944 19.5503 8.84017 19.2789 10.8632C19.0063 12.896 17.6906 15.1951 14.9042 17.2575C14.8809 17.2747 14.8578 17.2918 14.8348 17.3088C13.8672 18.0254 13.2264 18.5 12.1664 18.5C11.1064 18.5 10.4656 18.0254 9.49802 17.3088C9.47508 17.2918 9.45195 17.2747 9.42863 17.2575C6.64223 15.1951 5.3265 12.896 5.05387 10.8632C4.78255 8.84017 5.55577 7.07944 6.92993 6.23653M12.5558 6.31214C12.3786 6.4452 12.2569 6.53628 12.1664 6.59778C12.0759 6.53628 11.9542 6.4452 11.777 6.31214"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconPlay = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M14.4825 10.6014C15.3044 11.058 15.7154 11.2863 15.8518 11.5873C15.9706 11.8496 15.9706 12.1504 15.8518 12.4128C15.7154 12.7137 15.3044 12.942 14.4825 13.3987L10.3771 15.6794C9.59506 16.1139 9.20405 16.3311 8.88404 16.2937C8.60482 16.2611 8.35223 16.1125 8.18813 15.8843C8.00004 15.6227 8.00004 15.1754 8.00004 14.2808L8.00004 9.71924C8.00004 8.82464 8.00004 8.37734 8.18813 8.11575C8.35223 7.88752 8.60482 7.73889 8.88404 7.70628C9.20405 7.6689 9.59505 7.88613 10.3771 8.32058L14.4825 10.6014Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconPlus = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.25011C12.4142 4.25011 12.75 4.5859 12.75 5.00011L12.75 19.0001C12.75 19.4143 12.4142 19.7501 12 19.7501C11.5858 19.7501 11.25 19.4143 11.25 19.0001L11.25 5.00011C11.25 4.5859 11.5858 4.25011 12 4.25011Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.75 12.0001C19.75 12.4143 19.4142 12.7501 19 12.7501L5 12.7501C4.58579 12.7501 4.25 12.4143 4.25 12.0001C4.25 11.5859 4.58579 11.2501 5 11.2501L19 11.2501C19.4142 11.2501 19.75 11.5859 19.75 12.0001Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconPrinter = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <g clipPath="url(#clip0_6725_33834)">
          <path
            d="M8.48008 13.3129C8.31963 13.3346 8.15959 13.3577 8 13.3823M8.48008 13.3129C9.63305 13.1572 10.8078 13.0769 12 13.0769C13.1922 13.0769 14.3669 13.1572 15.5199 13.3129M8.48008 13.3129L8.22727 16.3077M15.5199 13.3129C15.6804 13.3346 15.8404 13.3577 16 13.3823M15.5199 13.3129L15.7727 16.3077M8.22727 16.3077L8.07435 18.1192C8.03443 18.5922 8.38025 19 8.82127 19H15.1787C15.6197 19 15.9656 18.5922 15.9257 18.1192L15.7727 16.3077M8.22727 16.3077H7.5C6.67157 16.3077 6 15.5845 6 14.6923V10.1733C6 9.39726 6.51193 8.72674 7.22463 8.6119C7.64711 8.54383 8.07229 8.48465 8.5 8.43454M15.7727 16.3077H16.5C17.3284 16.3077 18 15.5845 18 14.6923V10.1733C18 9.39726 17.4881 8.72674 16.7754 8.6119C16.3529 8.54383 15.9277 8.48465 15.5 8.43454M15.5 8.43454C14.3505 8.29987 13.1827 8.23077 12 8.23077C10.8173 8.23077 9.64949 8.29987 8.5 8.43454M15.5 8.43454V5.80769C15.5 5.36162 15.1642 5 14.75 5H9.25C8.83579 5 8.5 5.36162 8.5 5.80769V8.43454M16 10.9231H16.005V10.9285H16V10.9231ZM14 10.9231H14.005V10.9285H14V10.9231Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_6725_33834">
            <rect width="24" height="24" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
    )
  }),
)

export const IconQr = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.53123 5C5.68555 5 5 5.68514 5 6.53029V9.59088C5 10.436 5.68555 11.1212 6.53123 11.1212H9.59369C10.4394 11.1212 11.1249 10.436 11.1249 9.59088V6.53029C11.1249 5.68514 10.4394 5 9.59369 5H6.53123ZM6.31248 6.53029C6.31248 6.40956 6.41042 6.31168 6.53123 6.31168H9.59369C9.7145 6.31168 9.81244 6.40956 9.81244 6.53029V9.59088C9.81244 9.71162 9.7145 9.8095 9.59369 9.8095H6.53123C6.41042 9.8095 6.31248 9.71162 6.31248 9.59088V6.53029ZM6.53123 12.8701C5.68555 12.8701 5 13.5552 5 14.4004V17.461C5 18.3061 5.68555 18.9913 6.53123 18.9913H9.59369C10.4394 18.9913 11.1249 18.3061 11.1249 17.461V14.4004C11.1249 13.5552 10.4394 12.8701 9.59369 12.8701H6.53123ZM6.31248 14.4004C6.31248 14.2796 6.41042 14.1818 6.53123 14.1818H9.59369C9.7145 14.1818 9.81244 14.2796 9.81244 14.4004V17.461C9.81244 17.5817 9.7145 17.6796 9.59369 17.6796H6.53123C6.41042 17.6796 6.31248 17.5817 6.31248 17.461V14.4004ZM12.8749 6.53029C12.8749 5.68514 13.5605 5 14.4061 5H17.4686C18.3143 5 18.9998 5.68514 18.9998 6.53029V9.59088C18.9998 10.436 18.3143 11.1212 17.4686 11.1212H14.4061C13.5605 11.1212 12.8749 10.436 12.8749 9.59088V6.53029ZM14.4061 6.31168C14.2853 6.31168 14.1874 6.40956 14.1874 6.53029V9.59088C14.1874 9.71162 14.2853 9.8095 14.4061 9.8095H17.4686C17.5894 9.8095 17.6873 9.71162 17.6873 9.59088V6.53029C17.6873 6.40956 17.5894 6.31168 17.4686 6.31168H14.4061ZM8.05391 7.18613C7.57067 7.18613 7.17892 7.57765 7.17892 8.06059V8.06933C7.17892 8.55229 7.57067 8.94379 8.05391 8.94379H8.06266C8.54591 8.94379 8.93765 8.55229 8.93765 8.06933V8.06059C8.93765 7.57765 8.54591 7.18613 8.06266 7.18613H8.05391ZM15.9288 7.18613C15.4455 7.18613 15.0538 7.57765 15.0538 8.06059V8.06933C15.0538 8.55229 15.4455 8.94379 15.9288 8.94379H15.9375C16.4208 8.94379 16.8125 8.55229 16.8125 8.06933V8.06059C16.8125 7.57765 16.4208 7.18613 15.9375 7.18613H15.9288ZM8.05391 15.0562C7.57067 15.0562 7.17892 15.4477 7.17892 15.9307V15.9394C7.17892 16.4224 7.57067 16.8139 8.05391 16.8139H8.06266C8.54591 16.8139 8.93765 16.4224 8.93765 15.9394V15.9307C8.93765 15.4477 8.54591 15.0562 8.06266 15.0562H8.05391ZM15.9288 15.0562C15.4455 15.0562 15.0538 15.4477 15.0538 15.9307V15.9394C15.0538 16.4224 15.4455 16.8139 15.9288 16.8139H15.9375C16.4208 16.8139 16.8125 16.4224 16.8125 15.9394V15.9307C16.8125 15.4477 16.4208 15.0562 15.9375 15.0562H15.9288ZM12.8663 13.7445C12.8663 13.2616 13.2581 12.8701 13.7413 12.8701H13.7501C14.2333 12.8701 14.6251 13.2616 14.6251 13.7445V13.7533C14.6251 14.2362 14.2333 14.6277 13.7501 14.6277H13.7413C13.2581 14.6277 12.8663 14.2362 12.8663 13.7533V13.7445ZM18.1163 12.8701C17.633 12.8701 17.2413 13.2616 17.2413 13.7445V13.7533C17.2413 14.2362 17.633 14.6277 18.1163 14.6277H18.125C18.6083 14.6277 19 14.2362 19 13.7533V13.7445C19 13.2616 18.6083 12.8701 18.125 12.8701H18.1163ZM17.2413 18.1168C17.2413 17.6338 17.633 17.2423 18.1163 17.2423H18.125C18.6083 17.2423 19 17.6338 19 18.1168V18.1255C19 18.6085 18.6083 19 18.125 19H18.1163C17.633 19 17.2413 18.6085 17.2413 18.1255V18.1168ZM13.7413 17.2423C13.2581 17.2423 12.8663 17.6338 12.8663 18.1168V18.1255C12.8663 18.6085 13.2581 19 13.7413 19H13.7501C14.2333 19 14.6251 18.6085 14.6251 18.1255V18.1168C14.6251 17.6338 14.2333 17.2423 13.7501 17.2423H13.7413Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconRadioCheck = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
          fill="currentColor"
        ></path>
        <path d="M10 12.5L11.6667 14L14 10.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
      </svg>
    )
  }),
)

export const IconRadioOff = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <circle cx="12" cy="12" r="5.5" fill="white" stroke="#E5E5E5"></circle>
      </svg>
    )
  }),
)

export const IconRadioOn = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
          fill="currentColor"
        ></path>
        <path
          d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconSearch = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9231 6.07692C8.24662 6.07692 6.07692 8.24662 6.07692 10.9231C6.07692 13.5995 8.24662 15.7692 10.9231 15.7692C12.2615 15.7692 13.4723 15.2274 14.3498 14.3498C15.2274 13.4723 15.7692 12.2615 15.7692 10.9231C15.7692 8.24662 13.5995 6.07692 10.9231 6.07692ZM5 10.9231C5 7.65185 7.65185 5 10.9231 5C14.1943 5 16.8462 7.65185 16.8462 10.9231C16.8462 12.3646 16.3307 13.6865 15.4748 14.7133L18.8423 18.0808C19.0526 18.2911 19.0526 18.632 18.8423 18.8423C18.632 19.0526 18.2911 19.0526 18.0808 18.8423L14.7133 15.4748C13.6865 16.3307 12.3646 16.8462 10.9231 16.8462C7.65185 16.8462 5 14.1943 5 10.9231Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconTicket = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.8 21C6.80589 21 6 20.1845 6 19.1786L6 5.82143C6 4.81548 6.80589 4 7.8 4L9 4C9.33137 4 9.5923 4.27605 9.67406 4.601C9.93836 5.65157 10.8795 6.42857 12 6.42857C13.1205 6.42857 14.0616 5.65157 14.3259 4.601C14.4077 4.27605 14.6686 4 15 4L16.2 4C17.1941 4 18 4.81548 18 5.82143V19.1786C18 20.1845 17.1941 21 16.2 21L15 21C14.6686 21 14.4077 20.724 14.3259 20.399C14.0616 19.3484 13.1205 18.5714 12 18.5714C10.8795 18.5714 9.93836 19.3484 9.67406 20.399C9.5923 20.724 9.33137 21 9 21L7.8 21ZM9.3 10.0714C8.80294 10.0714 8.4 9.66369 8.4 9.16071C8.4 8.65774 8.80294 8.25 9.3 8.25L10.5 8.25C10.9971 8.25 11.4 8.65774 11.4 9.16071C11.4 9.66369 10.9971 10.0714 10.5 10.0714L9.3 10.0714ZM12.6 9.16071C12.6 9.66369 13.0029 10.0714 13.5 10.0714L14.7 10.0714C15.1971 10.0714 15.6 9.66369 15.6 9.16071C15.6 8.65774 15.1971 8.25 14.7 8.25L13.5 8.25C13.0029 8.25 12.6 8.65774 12.6 9.16071Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconUnmuted = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M11.6192 6.16552L8.23076 9.69543H6.62188C5.99056 9.69543 5.39911 10.0742 5.23145 10.7083C5.08058 11.2788 5 11.8796 5 12.5001C5 13.1206 5.08058 13.7214 5.23145 14.2919C5.39911 14.926 5.99056 15.3048 6.62188 15.3048H8.23076L11.6192 18.8347C11.9584 19.1881 12.5384 18.9378 12.5384 18.438V6.56216C12.5384 6.06242 11.9584 5.81215 11.6192 6.16552Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.993 6.50093C11.9918 6.50159 11.9872 6.50425 11.9799 6.51177L8.59147 10.0417C8.49718 10.1399 8.36691 10.1954 8.23076 10.1954H6.62188C6.17945 10.1954 5.81531 10.4561 5.71483 10.8361C5.57493 11.3652 5.5 11.9231 5.5 12.5001C5.5 13.0771 5.57493 13.635 5.71483 14.1641C5.81531 14.5441 6.17945 14.8048 6.62188 14.8048H8.23076C8.36691 14.8048 8.49718 14.8603 8.59147 14.9585L11.9799 18.4884C11.9872 18.496 11.9918 18.4986 11.993 18.4993C11.9943 18.5 11.9948 18.5 11.9948 18.5C11.995 18.5 11.9997 18.5008 12.0079 18.4972C12.0162 18.4936 12.0235 18.4876 12.0284 18.4804C12.032 18.4751 12.0384 18.4634 12.0384 18.438V6.56216C12.0384 6.53684 12.032 6.52511 12.0284 6.51982C12.0235 6.5126 12.0162 6.50658 12.0079 6.50301C11.9997 6.49944 11.995 6.50016 11.9948 6.50019C11.9948 6.50019 11.9943 6.50021 11.993 6.50093ZM11.2585 5.81927C11.9403 5.10907 13.0384 5.6567 13.0384 6.56216V18.438C13.0384 19.3435 11.9403 19.8911 11.2585 19.1809L8.01764 15.8048H6.62188C5.80167 15.8048 4.98291 15.3079 4.74806 14.4197C4.58624 13.8078 4.5 13.164 4.5 12.5001C4.5 11.8362 4.58624 11.1924 4.74806 10.5805C4.98291 9.69231 5.80167 9.19543 6.62188 9.19543H8.01764L11.2585 5.81927ZM16.7612 7.37966C16.9604 7.18843 17.2769 7.1949 17.4682 7.39412C20.1773 10.2163 20.1773 14.7838 17.4682 17.606C17.2769 17.8052 16.9604 17.8117 16.7612 17.6205C16.562 17.4292 16.5555 17.1127 16.7468 16.9135C19.0844 14.4783 19.0844 10.5219 16.7468 8.08662C16.5555 7.88741 16.562 7.57089 16.7612 7.37966ZM14.8577 9.36293C15.0569 9.1717 15.3734 9.17817 15.5646 9.37738C17.2223 11.1043 17.2223 13.896 15.5646 15.6229C15.3734 15.8221 15.0569 15.8285 14.8577 15.6373C14.6585 15.4461 14.652 15.1296 14.8432 14.9304C16.1295 13.5904 16.1295 11.4098 14.8432 10.0699C14.652 9.87068 14.6585 9.55416 14.8577 9.36293Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconWallet = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <g clipPath="url(#clip0_6725_33835)">
          <path
            d="M19 12C19 11.0963 18.2165 10.3636 17.25 10.3636H14.3333C14.3333 11.5686 13.2887 12.5455 12 12.5455C10.7113 12.5455 9.66667 11.5686 9.66667 10.3636H6.75C5.7835 10.3636 5 11.0963 5 12M19 12V16.3636C19 17.2674 18.2165 18 17.25 18H6.75C5.7835 18 5 17.2674 5 16.3636V12M19 12V9.81818M5 12V9.81818M19 9.81818C19 8.91444 18.2165 8.18182 17.25 8.18182H6.75C5.7835 8.18182 5 8.91444 5 9.81818M19 9.81818V7.63636C19 6.73263 18.2165 6 17.25 6H6.75C5.7835 6 5 6.73262 5 7.63636V9.81818"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_6725_33835">
            <rect width="24" height="24" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
    )
  }),
)

export type IconName =
  | "access"
  | "account"
  | "calendar"
  | "caretDown"
  | "cart"
  | "chevronDown"
  | "chevronLeft"
  | "chevronRight"
  | "chevronUp"
  | "cross"
  | "day"
  | "download"
  | "ellipsis"
  | "externalLink"
  | "film"
  | "filters"
  | "gift"
  | "guest"
  | "info"
  | "link"
  | "load"
  | "menu"
  | "minus"
  | "money"
  | "muted"
  | "placeholder"
  | "planner"
  | "plannerEmpty"
  | "play"
  | "plus"
  | "printer"
  | "qr"
  | "radioCheck"
  | "radioOff"
  | "radioOn"
  | "search"
  | "ticket"
  | "unmuted"
  | "wallet"

type IconProps = Omit<SVGProps, "name"> & { name: IconRef | undefined }
type IconComponent = (props: SVGProps) => ReactElement
type IconSet = { [K in IconName]: IconComponent }

export const ICONS = {
  access: IconAccess,
  account: IconAccount,
  calendar: IconCalendar,
  caretDown: IconCaretDown,
  cart: IconCart,
  chevronDown: IconChevronDown,
  chevronLeft: IconChevronLeft,
  chevronRight: IconChevronRight,
  chevronUp: IconChevronUp,
  cross: IconCross,
  day: IconDay,
  download: IconDownload,
  ellipsis: IconEllipsis,
  externalLink: IconExternalLink,
  film: IconFilm,
  filters: IconFilters,
  gift: IconGift,
  guest: IconGuest,
  info: IconInfo,
  link: IconLink,
  load: IconLoad,
  menu: IconMenu,
  minus: IconMinus,
  money: IconMoney,
  muted: IconMuted,
  placeholder: IconPlaceholder,
  planner: IconPlanner,
  plannerEmpty: IconPlannerEmpty,
  play: IconPlay,
  plus: IconPlus,
  printer: IconPrinter,
  qr: IconQr,
  radioCheck: IconRadioCheck,
  radioOff: IconRadioOff,
  radioOn: IconRadioOn,
  search: IconSearch,
  ticket: IconTicket,
  unmuted: IconUnmuted,
  wallet: IconWallet,
} as IconSet

export type IconRef = IconName | ReactElement

export function Icon(props: IconProps) {
  if (!props.name) return null
  if (isValidElement(props.name)) {
    return props.name
  }
  const { name, ...rest } = props
  if (typeof name === "string" && name in ICONS) {
    const IconComponent = ICONS[name]
    return <IconComponent className="icon" {...rest} />
  }
  return props.name
}
